import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { VALUES } from 'utils/constants'
import UserProfilePopover from '../UserProfilePopover'
import NotificationsSummaryPopover from '../NotificationsSummaryPopover'
import Breadcrumbs from '../Breadcrumbs'
import { NotificationsNone, HelpOutline } from '@material-ui/icons'
import logoZonaSer from 'images/zona ser.png'
import { useStateValue } from 'context/store'
import { getLocalstorageItem } from 'utils/localStorage'
import { LOCALSTORAGE_KEYS } from 'utils/constants'
import WebSocketService from 'services/WebSocketService'
import { getFromApi } from 'actions'
import cloneDeep from 'lodash/cloneDeep'
import HelpPopover from '../HelpPopover'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import {
   makeStyles,
   AppBar,
   Toolbar,
   IconButton,
   Divider
} from '@material-ui/core'
import UserAvatar from 'components/UserAvatar'


const useStyles = makeStyles(theme => ({
   appBar: {
      height: '47px',
      background: "white !important",
      zIndex: theme.zIndex.drawer + 1,
      width: `calc(100% - ${VALUES.MENU.CLOSED_MAIN_DRAWER_WIDTH}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen
      })
   },
   appBarShift: {
      height: '47px',
      marginLeft: VALUES.MENU.OPEN_MAIN_DRAWER_WIDTH,
      width: `calc(100% - ${VALUES.MENU.OPEN_MAIN_DRAWER_WIDTH}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.enteringScreen
      })
   },
   toolbar: {
      minHeight: '47px',
      padding: theme.spacing(0, 2),
      display: 'flex',
      justifyContent: 'flex-start'
   },
   toolbarIconsContainer: {
      display: 'flex',
      alignItems: 'center'
   },
   toolbarLogo: {
      height: '30px',
      cursor: 'pointer'
   },
   menuButton: {
      marginRight: 36
   },
   hide: {
      display: 'none'
   },
   avatarContainer: {
      width: 32,
      height: 32,
      marginLeft: theme.spacing(1),
      boxShadow: '0px 1px 1px #00000029',
      border: '4px solid #FFFFFF',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
   },
   avatar: {
      width: 26,
      height: 26
   },
   icons: {
      color: '#8A8FAB'
   },
   dot: {
      height: 4,
      width: 4,
      borderRadius: '50%',
      display: 'inline-block',
      backgroundColor: '#E55454',
      position: 'absolute',
      right: 16
   }
}))

const notificationsSocketUrl = `${process.env.REACT_APP_NOTIFICATIONS_SOCKET}`

const Header = ({ history }) => {
   const classes = useStyles()
   const [
      {
         sessionUser,
         notifications = [],
         notificationsSummary = [],
         regulations = [],
         regulationsSummary = []
      },
      dispatch
   ] = useStateValue()

   const [userProfileAnchorEl, setUserProfileAnchorEl] = useState(null)
   const [helpPopoverAnchorEl, setHelpPopoverAnchorEL] = useState(null)
   const [notificationsSummaryAnchorEl, setNotificationsSummaryAnchorEl] =
      useState(null)
   const [addDotToIcon, setAddDotToIcon] = useState(false)
   const [notificationsConfigs, setNotificationsConfigs] = useState([])
   const [newNotification, setNewNotification] = useState({})
   const [newRegulation, setNewRegulation] = useState({})

   const userSettings = sessionUser?.settings

   useEffect(() => {
      const userState = getLocalstorageItem(LOCALSTORAGE_KEYS.STATE, true)
      const tokenApp = userState?.accessToken
      const userEmail = userSettings?.email
      new WebSocketService() // Singleton
      const notificationsSocket = WebSocketService.getInstance()
      notificationsSocket.connect(
         notificationsSocketUrl,
         tokenApp,
         userEmail,
         onGetOneNotification,
         onGetOneRegulation
      )
      getNotificationsSummary()
      getNotificationsConfig()
      getRegulationsSummary()
   }, []) // eslint-disable-line react-hooks/exhaustive-deps

   // ---------------- Notifications -----------------
   async function _getNotificationsSummary() {
      const payload = {
         page: 0,
         size: VALUES.NOTIFICATIONS_SUMMARY_MAX_ITEMS,
         order: 'desc'
      }
      const url = `${process.env.REACT_APP_NOTIFICATIONS_API}/notifications/search`
      const { data } = await getFromApi(url, payload)
      dispatch({
         type: 'SET_NOTIFICATIONS_SUMMARY',
         notificationsSummaryData: data
      })
   }

   const getNotificationsSummary = useApiRequest(
      _getNotificationsSummary,
      'Resumen Notificaciones: Consultar',
      false
   )

   async function _getNotificationsConfig() {
      const url = `${process.env.REACT_APP_NOTIFICATIONS_API}/notifications/config`
      const searchedConfigs = await getFromApi(url)
      const configs = {}
      searchedConfigs.forEach(subdomainConfig => {
         const {
            subdomain: { name: subdomainName, code: subdomainCode },
            configurations
         } = subdomainConfig
         configs[subdomainCode] = {
            subdomainName,
            subdomainStatus: false,
            applications: {}
         }
         configurations.forEach(appConfig => {
            const {
               application: { code: appCode, name: appName },
               status: appStatus
            } = appConfig
            configs[subdomainCode].applications[appCode] = {
               appName,
               appStatus: appStatus === 'A'
            }
            if (!configs[subdomainCode].subdomainStatus && appStatus === 'A') {
               configs[subdomainCode].subdomainStatus = true
            }
         })
      })
      setNotificationsConfigs(configs)
   }

   const getNotificationsConfig = useApiRequest(
      _getNotificationsConfig,
      'Configuración Notificaciones: Consultar',
      false
   )

   function onGetOneNotification(notification) {
      if (notification) {
         setAddDotToIcon(true)
         setNewNotification(notification)
      }
   }

   useEffect(() => {
      if (Object.keys(newNotification).length) {
         // Para resumen de notificaciones
         const newNotificationsSummary = [
            newNotification,
            ...notificationsSummary.slice(
               0,
               VALUES.NOTIFICATIONS_SUMMARY_MAX_ITEMS - 1
            )
         ]
         dispatch({
            type: 'SET_NOTIFICATIONS_SUMMARY',
            notificationsSummaryData: newNotificationsSummary
         })
         // Para "Ver Todas" las notificaciones
         const newList = cloneDeep(notifications)
         const notificationsData = [
            newNotification,
            ...newList.slice(0, newList.length)
         ]
         dispatch({
            type: 'SET_ALL_NOTIFICATIONS_LIST',
            notificationsData
         })
      }
   }, [newNotification]) // eslint-disable-line react-hooks/exhaustive-deps

   // ------------------- Regulations -----------------------
   async function _getRegulationsSummary() {
      const payload = {
         page: 0,
         size: VALUES.NOTIFICATIONS_SUMMARY_MAX_ITEMS,
         order: 'desc'
      }
      const url = `${process.env.REACT_APP_NOTIFICATIONS_API}/circulars-regulations/search`
      const { data: regulationsSummary } = await getFromApi(url, payload)
      dispatch({
         type: 'SET_REGULATIONS_SUMMARY',
         regulationsSummary
      })
   }

   const getRegulationsSummary = useApiRequest(
      _getRegulationsSummary,
      'Resumen Circulares/Normativas: Consultar',
      false
   )

   function onGetOneRegulation(regulation) {
      if (regulation) {
         setNewRegulation(regulation)
      }
   }

   useEffect(() => {
      if (Object.keys(newRegulation).length) {
         // Para resumen de normativas
         const newRegulationsSummary = [
            newRegulation,
            ...regulationsSummary.slice(
               0,
               VALUES.NOTIFICATIONS_SUMMARY_MAX_ITEMS - 1
            )
         ]
         dispatch({
            type: 'SET_REGULATIONS_SUMMARY',
            regulationsSummary: newRegulationsSummary
         })
         // Para historial de normativas
         const newList = cloneDeep(regulations)
         const regulationsData = [
            newRegulation,
            ...newList.slice(0, newList.length)
         ]
         dispatch({
            type: 'SET_ALL_REGULATIONS_LIST',
            regulationsData
         })
      }
   }, [newRegulation]) // eslint-disable-line react-hooks/exhaustive-deps

   // ---------------- Handle button clicks --------------
   function handleHomeClick(event) {
      event.preventDefault()
      if (
         userSettings?.isAdmin ||
         (sessionUser?.authenticated && userSettings?.policiesAccepted)
      ) {
         history.push('/dashboard')
      }
   }

   function handleAvatarClick(event) {
      setUserProfileAnchorEl(event.currentTarget)
   }

   function handleNotificactionsSummaryClick(event) {
      if (addDotToIcon) {
         setAddDotToIcon(false)
      }
      setNotificationsSummaryAnchorEl(event.currentTarget)
   }

   function handleHelpClick(event) {
      setHelpPopoverAnchorEL(event.currentTarget)
   }

   return (
      <AppBar elevation={0} position="fixed" className={classes.appBar}>
         <Toolbar disableGutters className={classes.toolbar}>
            <div
               className={classes.toolbarIconsContainer}
               onClick={handleHomeClick}
            >
               <img
                  className={classes.toolbarLogo}
                  src={logoZonaSer}
                  alt={'Logo Zona Ser'}
               />
            </div>
            <Breadcrumbs />
            <div className={classes.toolbarIconsContainer}>
               <IconButton
                  className={classes.icons}
                  onClick={handleHelpClick}
                  data-wt="welcometour_help"
               >
                  <HelpOutline fontSize="small" />
               </IconButton>
               <HelpPopover
                  anchorEl={helpPopoverAnchorEl}
                  setAnchorEl={setHelpPopoverAnchorEL}
               />
               <IconButton
                  className={classes.icons}
                  onClick={handleNotificactionsSummaryClick}
                  data-wt="welcometour_notificationssummary"
               >
                  <NotificationsNone fontSize="small" />
                  {addDotToIcon && <span className={classes.dot}></span>}
               </IconButton>
               <NotificationsSummaryPopover
                  anchorEl={notificationsSummaryAnchorEl}
                  setAnchorEl={setNotificationsSummaryAnchorEl}
                  notificationsConfigs={notificationsConfigs}
                  setNotificationsConfigs={setNotificationsConfigs}
               />
               <div
                  className={classes.avatarContainer}
                  data-wt="welcometour_userprofile"
               >
                  <UserAvatar
                     onClick={handleAvatarClick}
                     extraClass={classes.avatar}
                  />
               </div>
               <UserProfilePopover
                  anchorEl={userProfileAnchorEl}
                  setAnchorEl={setUserProfileAnchorEl}
               />
            </div>
         </Toolbar>
         <Divider variant="middle" />
      </AppBar>
   )
}

export default withRouter(Header)
